import { ReactElement } from "react";
import dynamic from "next/dynamic";
import * as Yup from "yup";

import {
  deliveryInfoSchemaUK,
  deliveryInfoSchemaUZ,
  deliveryPaymentSchemaUZ,
} from "@/validations/courier/courier.validation";
import { Theme } from "@/enums";

const DeliveryInfoUz = dynamic(
  () => import("@/components/dashboard/courier-service/delivery-info-uz"),
  { ssr: false },
);
const DeliveryPayment = dynamic(
  () => import("@/components/dashboard/courier-service/delivery-payment"),
  { ssr: false },
);
const DeliveryInfoUk = dynamic(
  () => import("@/components/dashboard/courier-service/delivery-info-uk"),
  { ssr: false },
);

export const courierServiceForm: {
  [key in Theme]: {
    "delivery-info": {
      stepName: string;
      component: ReactElement<any, any>;
      validationSchema: Yup.ObjectSchema<any>;
    };
    "delivery-payment"?: {
      stepName: string;
      component: ReactElement<any, any>;
      validationSchema: Yup.ObjectSchema<any>;
    };
  };
} = {
  [Theme.GEORGIA]: {
    "delivery-info": {
      stepName: "courier_services",
      component: <DeliveryInfoUz />,
      validationSchema: null,
    },
  },
  [Theme.UK]: {
    "delivery-info": {
      stepName: "courier_services",
      component: <DeliveryInfoUk />,
      validationSchema: deliveryInfoSchemaUK,
    },
    // "delivery-payment": {
    //   stepName: "payments",
    //   component: <DeliveryPayment />,
    //   validationSchema: deliveryPaymentSchemaUZ,
    // },
  },
  [Theme.UZ]: {
    "delivery-info": {
      stepName: "courier_services",
      component: <DeliveryInfoUz />,
      validationSchema: deliveryInfoSchemaUZ,
    },
    "delivery-payment": {
      stepName: "payments",
      component: <DeliveryPayment />,
      validationSchema: deliveryPaymentSchemaUZ,
    },
  },
};
